import { PlanterStatus } from "./PlanterMiniGameTypes";

/**
 * API service for the Planter Mini Game
 */
export class PlanterMiniGameApi {
    private readonly baseUrl: string;

    /**
     * Constructor for the API service
     */
    public constructor() {
        this.baseUrl = `${window.location.protocol}//${window.location.hostname}:3001/game`;
    }

    /**
     * Check if the planter mini-game has been completed
     * @param sessionId The player session ID
     * @returns Promise resolving to the planter status
     */
    public async checkGameCompletion(sessionId: string): Promise<PlanterStatus> {
        try {
            const response: Response = await fetch(`${this.baseUrl}/check-planter-status`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-PlayerSessionId": sessionId,
                },
            });

            if (response.ok) {
                return await response.json() as PlanterStatus;
            }
            return { plantWatered: false };
        }
        catch (error: unknown) {
            console.error("Error checking planter status:", error);
            return { plantWatered: false };
        }
    }

    /**
     * Save the mini-game progress
     * @param sessionId The player session ID
     * @param completed Whether the mini-game was completed
     * @returns Promise resolving to a boolean indicating success
     */
    public async saveMiniGameProgress(sessionId: string, completed: boolean): Promise<boolean> {
        try {
            const response: Response = await fetch(`${this.baseUrl}/save-planter-minigame`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-PlayerSessionId": sessionId,
                },
                body: JSON.stringify({ completed }),
            });

            return response.ok;
        }
        catch (error: unknown) {
            console.error("Error saving mini-game progress:", error);
            return false;
        }
    }
}
